var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-tooltip',{attrs:{"text":("Канал: " + (_vm.currentClient.channel))}},[_c('button',{staticClass:"messenger-close-button"},[_c('feather-icon',{attrs:{"icon":"InfoIcon"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }